<script setup lang="ts">
import { useAnalyticsLayoutStore } from '@/stores/analyticsLayoutStore'
import AnalyticsDashboard from '@/views/apps/analytics/AnalyticsDashboard.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'Analytics',
  },
})

const store = useAnalyticsLayoutStore()

onMounted(async () => {
  await store.initCatalog()
  await store.initCanvas()
})
</script>

<template>
  <AnalyticsDashboard />
</template>
